import { DashboardModule, Form, Grid } from '@domain-group/suit-theme'

import EntitySelectBox from '@components/EntitySelectBox'

import type { AgencyModel } from '@models/types'

interface AddressDetailsProps {
  agencySalesforceDetails: AgencyModel['salesforce_details'],
}

const AddressDetails = (props: AddressDetailsProps) => {
  const { agencySalesforceDetails } = props

  const addressDetailsPayload = [
    { label: 'Address Line 1', value: agencySalesforceDetails?.address_line_1 },
    { label: 'Address Region', value: agencySalesforceDetails?.address_region },
    { label: 'State', value: agencySalesforceDetails?.address_state },
    { label: 'Postcode', value: agencySalesforceDetails?.address_postcode },
  ]

  return (
    <DashboardModule title="Address">
      <Grid
        // @ts-expect-error TS2322
        gridGap="large"
        gridTemplateColumns={[
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(2, minmax(160px, 1fr))',
        ]}
        padding="large"
      >
        {addressDetailsPayload.map(field => (
          <Form.Field label={field.label}>
            <input
              disabled
              type="text"
              value={field.value}
            />
          </Form.Field>
        ))}

        <Form.Field label="Country">
          <EntitySelectBox
            data-value-type="number"
            // @ts-expect-error TS2322
            disabled
            entityKey="geoCountries"
            name="geo_country_id"
            sortDirection="asc"
            sortKey="title"
            value={agencySalesforceDetails?.geo_country_id}
          />
        </Form.Field>
      </Grid>
    </DashboardModule>
  )
}

export default AddressDetails
